// extracted by mini-css-extract-plugin
export default {"row":"HomePage_row__5FhVA","platform_card":"HomePage_platform_card__c4r-8"};